import { Table } from "antd";

const Table1 = () => {
    const dataSource = [
        {
            key: '1',
            stt: '1',
            service: 'Phí cài đặt',
            level1: 'Miễn phí',
            level2: '',
            note: '',
        },
        {
            key: '2',
            stt: '2',
            service: 'Phí duy trì hệ thống',
            level1: 'Miễn phí',
            level2: '',
            note: '',
        },
        {
            key: '3',
            stt: '3',
            service: 'TOKENIZATION',
            level1: '',
            level2: '',
            note: '',
        },
        {
            key: '4',
            stt: '4',
            service: 'Cổng Nội địa',
            level1: '1.100 VNĐ + 0,89%',
            level2: '3%',
            note: '',
        },

        // Thẻ quốc tế - row 1
        {
            key: '5-1',
            stt: '5',
            service: 'Thẻ Quốc tế phát hành trong nước',
            level1: '2.500 VNĐ + 2,50%',
            level2: '2.500 VNĐ + (2,51% - 2,85%)',
            note: 'Loại hình Kinh doanh khác',
        },

        // Thẻ quốc tế - row 2
        {
            key: '5-2',
            stt: '5',
            service: 'Thẻ Quốc tế phát hành trong nước',
            level1: '2.500 VNĐ + 1,35%',
            level2: '2.500 VNĐ + 1,75%',
            note: 'Phí vệ sinh, nộp thuế, phí cầu đường, dịch vụ vận tải công, thanh toán hoá đơn',
        },

        // Thẻ quốc tế - row 3
        {
            key: '5-3',
            stt: '5',
            service: 'Thẻ Quốc tế phát hành trong nước',
            level1: '2.500 VNĐ + 1,65%',
            level2: '2.500 VNĐ + 2,0%',
            note: 'Bảo hiểm',
        },

        // Thẻ quốc tế - row 4
        {
            key: '5-4',
            stt: '5',
            service: 'Thẻ Quốc tế phát hành trong nước',
            level1: '2.500 VNĐ + 2,15%',
            level2: '2.500 VNĐ + 2,55%',
            note: 'Siêu thị, trường học, bệnh viện công (Thay đổi từ tháng 02/2024)',
        },

        // Thẻ quốc tế - row 5
        {
            key: '5-5',
            stt: '5',
            service: 'Thẻ Quốc tế phát hành trong nước',
            level1: '2.500 VNĐ + 1,65%',
            level2: '2.500 VNĐ + 1,95%',
            note: 'Nhà hàng thức ăn nhanh',
        },

        {
            key: '6',
            stt: '6',
            service: 'Phí xử lý hoàn tiền thẻ nội địa',
            level1: '2.200 VNĐ',
            level2: '',
            note: '',
            feeColSpan: true,
        },

        {
            key: '7',
            stt: '7',
            service: 'Phí xử lý hoàn tiền thẻ quốc tế',
            level1: '4.400 VNĐ',
            level2: '',
            note: '',
            feeColSpan: true,
        },
    ];

    const columns = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: 70,
            align: 'center',
        },
        {
            title: 'Dịch vụ',
            dataIndex: 'service',
            key: 'service',
            width: 290,

            onCell: (record, index) => {
                // Row 5 chỉ render service ở dòng đầu tiên
                if (record.key === '5-1') {
                    return {
                        rowSpan: 5,
                    };
                }

                if (
                    ['5-2', '5-3', '5-4', '5-5'].includes(record.key)
                ) {
                    return {
                        rowSpan: 0,
                    };
                }

                return {};
            },
        },
        {
            title: 'Mức phí/Giao dịch (đã bao gồm VAT)',
            children: [
                {
                    title: 'Mức 1',
                    dataIndex: 'level1',
                    key: 'level1',
                    width: 260,
                    align: 'center',

                    onCell: (record) => {
                        if (record.feeColSpan) {
                            return {
                                colSpan: 2,
                            };
                        }

                        return {};
                    },
                },
                {
                    title: 'Mức 2',
                    dataIndex: 'level2',
                    key: 'level2',
                    width: 260,
                    align: 'center',

                    onCell: (record) => {
                        if (record.feeColSpan) {
                            return {
                                colSpan: 0,
                            };
                        }

                        return {};
                    },
                },
            ],
        },
        {
            title: 'Ghi chú',
            dataIndex: 'note',
            key: 'note',
            width: 380,
            
        },
    ];
    return (
        <div>
            <h2 className="fw-bold fs-4 mb-3 text-center">BẢNG 1: PHÍ KINH DOANH ĐỀ XUẤT CHO CÁC DỊCH VỤ CỔNG THANH TOÁN</h2>
            <div>
                <Table
                    bordered
                    pagination={false}
                    dataSource={dataSource}
                    columns={columns}
                    rowKey="key"
                />
            </div>
        </div>

    );
};
export default Table1;